export const flags = {
  includeCellInputInPrompt: true,
}
